<script setup lang="ts">
import { useI18n } from 'vue-i18n'

defineOptions({ name: 'ErrorFallback' })

defineProps<{ error: unknown }>()
const emit = defineEmits<{ (e: 'reset'): void }>()
const { t } = useI18n()
</script>

<template>
  <div class="flex flex-col w-screen h-screen">
    <div class="flex flex-1 flex-col items-center justify-center px-6 text-center">
      <div class="text-body text-base mb-4">{{ t('requestFailed') }}</div>
      <button
        class="px-4 py-2 rounded-full bg-brand text-white text-sm"
        @click="emit('reset')"
      >
        {{ t('retry') }}
      </button>
    </div>
  </div>
</template>
